import React, {useEffect, useState} from "react";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextareaAutosize,
  styled,
} from "@mui/material";
import MWCaption from "../../components/MWCaption";

import PostAddIcon from "@mui/icons-material/PostAdd";
import {Controller, useFormContext} from "react-hook-form";
import MWInputFile from "../../components/MWInputFile";
import MWProgress from "../../components/MWProgress";
import {KPBoardSubCategory} from "../../models/serverModels/board/KPBoardSubCategory";
import {useGetQuery} from "../../hooks/useQueryHooks";
import {KPBoard, initializeBoardListParams} from "../../models/serverModels/board/KPBoard";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import * as boardApi from "../../api/boardApi/boardApi";
import {useRecoilValue} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {useParams} from "react-router-dom";

const ManageTableContainer = styled(Grid)(({theme}) => ({
  marginTop: "32px",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#fff",
}));

export const ManageTable = styled(TableContainer)(({theme}) => ({
  width: "80%",
  marginTop: "48px",
  marginBottom: "32px",
  paddingLeft: "16px",
  paddingTop: "32px",
  paddingRight: "16px",
  paddingBottom: "32px",
  backgroundColor: "#fff",
  boxShadow: `rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem`,

  "& .subTitle": {
    fontSize: "18px",
    fontWeight: 600,
  },
  "& table th, td": {
    border: `1px solid ${theme.palette.warning.main}`,

    [theme.breakpoints.down("sm")]: {
      padding: "8px",
    },
  },
  "& tbody th": {
    padding: "8px",
    width: "10%",
    color: theme.palette.warning.dark,
    fontWeight: 700,
    backgroundColor: theme.palette.warning.light,
  },
  "& tbody td": {
    width: "40%",
  },
  "& textarea": {
    lineHeight: 1.5,
  },

  [theme.breakpoints.down("lg")]: {
    width: "80%",
    padding: "8px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: 0,
  },
}));
const PostForm = () => {
  const {id} = useParams();

  const tokenState = useRecoilValue(tokenSelector);

  const [category, setCategory] = useState<KPBoardSubCategory[]>([]);

  const {data: board} = useGetQuery<ResponseItem<KPBoard>>({
    key: ["getBoardWithPosts"],
    api: () =>
      boardApi.getBoardWithPosts({
        ...initializeBoardListParams(parseInt(id!), 0),
        token: tokenState,
      }),
    // options: {
    //   onSuccess: (data: ResponseItem<KPBoard>) => {
    //     setCategory(data?.item?.subCategories!);
    //   },
    // },
  });

  const {control} = useFormContext();

  useEffect(() => {
    setCategory(board?.item?.subCategories!);
  }, [board?.item]);

  return (
    <React.Fragment>
      <ManageTableContainer container rowSpacing={4}>
        <MWCaption title={`${board?.item?.name} 작성`} color="#880E4F" icon={<PostAddIcon />} />

        <ManageTable>
          <Box sx={{margin: "auto", width: "100%"}}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell component="th">제목</TableCell>
                  <TableCell colSpan={3}>
                    <Controller
                      name="title"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <TextareaAutosize
                          defaultValue={value}
                          aria-label="minimum height"
                          minRows={1}
                          onChange={onChange}
                          style={{width: "100%", padding: "8px", resize: "none"}}
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th">분류</TableCell>
                  <TableCell colSpan={3}>
                    <Controller
                      name="subCategoryUID"
                      control={control}
                      render={({field}) => (
                        <Select
                          {...field}
                          style={{backgroundColor: "#fff", width: "100%"}}
                          name="subCategoryUID"
                          id="subCategoryUID"
                          size="small"
                          defaultValue={field.value}
                          onChange={field.onChange}
                        >
                          <MenuItem style={{display: "none"}} value={0}></MenuItem>

                          {category?.map((item) => (
                            <MenuItem
                              style={{backgroundColor: "#fff"}}
                              key={item.uid}
                              value={item?.uid}
                            >
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">내용</TableCell>
                  <TableCell colSpan={3}>
                    <Controller
                      name="contents"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <TextareaAutosize
                          defaultValue={value}
                          aria-label="minimum height"
                          minRows={3}
                          onChange={onChange}
                          style={{width: "100%", padding: "8px", resize: "none"}}
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                <TableCell component="th">링크이름</TableCell>
                  <TableCell>
                    <Controller
                      name="linkName"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <TextareaAutosize
                          defaultValue={value}
                          aria-label="minimum height"
                          minRows={1}
                          onChange={onChange}
                          style={{width: "100%", padding: "8px", resize: "none"}}
                        />
                      )}
                    />
                  </TableCell>
                  <TableCell component="th">외부링크</TableCell>
                  <TableCell>
                    <Controller
                      name="linkUrl"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <TextareaAutosize
                          defaultValue={value}
                          aria-label="minimum height"
                          minRows={1}
                          onChange={onChange}
                          style={{width: "100%", padding: "8px", resize: "none"}}
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" width="25%">
                    첨부이미지
                  </TableCell>
                  <TableCell>
                    <MWInputFile file="base64Image" fileName="imageFile" buttonLabel="찾기" />
                  </TableCell>
                  <TableCell component="th" width="25%">
                    파일선택
                  </TableCell>
                  <TableCell>
                    <MWInputFile
                      file="base64Attachment"
                      fileName="attachmentFile"
                      buttonLabel="찾기"
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </ManageTable>
      </ManageTableContainer>
    </React.Fragment>
  );
};

export default PostForm;
